import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
      themes: {
        light: {
            primary: '#F24653',
            secondary: '#5D647C',
            accent: '#77B2E8',
            error: '#F24653', // WAS F7CD66
            info: '#5D647C',
            success: '#75EABD',
            warning: '#F7CD66',
          },
      },
    },
  })
  
  export default vuetify
